module.exports = __webpack_public_path__ + "img/login_pop_logo.24489427.png";